angular.module('impactx.MenuDirectives').service('MessageService', [
    'PollingService',
    'ToastService',
    '$redirect',
    'AppConfiguration',
    'TranslationService',
    'dataGen',
    '$securityManager',
    MessageService]);

function MessageService(PollingService, ToastService, $redirect, AppConfiguration, TranslationService, dataGen, $securityManager) {
    var self = this;
    self.infoMessageCount = undefined;
    self.toDoMessageCount = undefined;

    self.setInfoMessageData = function (messageCount) {
        if (self.infoMessageCount !== undefined && messageCount > self.infoMessageCount) {
            if (self.canSendMessage()) {
                ToastService.openActionToast(TranslationService.get('newMessageReceived'), TranslationService.get('goToMailbox'), redirectToMailBox, null, '/messageinfolist');
            }
            else {
                ToastService.openStandardToast(TranslationService.get('newMessageReceived'));
            }
        }

        self.infoMessageCount = messageCount ? messageCount : 0;
    };

    self.setToDoMessageData = function (messageCount) {
        if (self.toDoMessageCount !== undefined && messageCount > self.toDoMessageCount) {
            if (self.canSendMessage()) {
                ToastService.openActionToast(TranslationService.get('newMessageReceived'), TranslationService.get('goToMailbox'), redirectToMailBox, null, '/messagetodolist');
            }
            else {
                ToastService.openStandardToast(TranslationService.get('newMessageReceived'));
            }
        }

        self.toDoMessageCount = messageCount ? messageCount : 0;
    };

    self.startInfoMessagePolling = function () {
        var messagePollingTime = AppConfiguration.get('messagePollingTime') * 1000;
        return PollingService.start('infoMessages', '/message/live/info', function (data) {
            self.setInfoMessageData(impactX.isDefined(data, 'data.numberOfUnreadMessages'));
        }, messagePollingTime);
    };

    self.startToDoMessagePolling = function () {
        var messagePollingTime = AppConfiguration.get('messagePollingTime') * 1000;
        return PollingService.start('toDoMessages', '/message/live/todo', function (data) {
            self.setToDoMessageData(impactX.isDefined(data, 'data.numberOfUnreadMessages'));
        }, messagePollingTime);
    };
    
    self.getInfoOnce = function() {
        dataGen.getData({}, {}, '/message/live/info').then(function(data) {
            self.setInfoMessageData(impactX.isDefined(data, 'data.numberOfUnreadMessages'));
        });
    };

    self.stopInfoMessagePolling = function () {
        self.infoMessageCount = undefined;
        PollingService.stop('infoMessages');
    };

    self.stopToDoMessagePolling = function () {
        self.toDoMessageCount = undefined;
        PollingService.stop('toDoMessages');
    };

    self.getInfoMessageCount = function () {
        return self.infoMessageCount;
    };

    self.getToDoMessageCount = function () {
        return self.toDoMessageCount;
    };

    self.canSendMessage = function () {
        return $securityManager.isProcessAllowed("SendMessage");
    };

    function redirectToMailBox(link) {
        $redirect.redirectTo(null, link);
    }

    return {
        startInfoMessagePolling: self.startInfoMessagePolling,
        startToDoMessagePolling: self.startToDoMessagePolling,
        stopInfoMessagePolling: self.stopInfoMessagePolling,
        stopToDoMessagePolling: self.stopToDoMessagePolling,
        getInfoMessageCount: self.getInfoMessageCount,
        getToDoMessageCount: self.getToDoMessageCount,
        getInfoOnce: self.getInfoOnce,
        canSendMessage: self.canSendMessage,
    };
}